export * from './text-generator';

export const whiteList = ['naturali', 'Naturali-BD'];
export const paginationConfig = {
  pageSize: 15
};

export const SYSTEM_ORG_NAME = 'system';
export const SYSTEM_AGENT_NAME = 'System';
export const USER_CACHE_KEY = 'framely-userData';
export const ORG_CACHE_KEY = 'duihualiu-org';
export const AGENT_CACHE_KEY = 'duihualiu-agent';

export const DEFAULT_TIMEZONE = 'America/Los_Angeles';

export const SYSTEM_CONTACT_FRAME_NAME = 'Contact';

export const FUNC_NAME_GET_ALL_LABELS = 'getAllLabels';

export const REFERENCE_SUFFIX = {
  ORIGINAL: 'original',
  CLOSURE: 'closure',
  SIZE: 'size'
};

export const AGENT_LAN = {
  EN: 'en',
  ZH: 'zh',
  STRUCT: 'struct'
};

export enum CONFLICT_RESOLVE_TYPE {
  MASTER,
  LOCAL
}

export enum ORG_ROLE {
  OWNER = 'owner',
  ADMIN = 'admin',
  MEMBER = 'member',
  OUTSIDER = 'outsider',
  INSIDER = 'insider'
}

export enum AGENT_ROLE {
  ADMIN = 'admin',
  WRITE = 'write',
  EDIT = 'edit',
  READ = 'read'
}

export enum PAGE_TYPE {
  AGENT = 'agent',
  INTENT = 'intent',
  COMPOSITE = 'composite',
  ENTITY = 'entity',
  SERVICE = 'service',
  ATTRIBUTE = 'attribute',
  CLOSURE = 'closure',
  RESPONSE = 'response',
  CONNECTION = 'connection',
  ENTITY_CONTENT = 'content',
  CONFIRMATION = 'confirmation',
  PHRASE = 'phrase',
  PROMPT = 'prompt',
  STATIC_TABLE = 'table',
  SUGGESTION = 'suggestion',
  COMPANION = 'companion',
  CHECK = 'check',
  STATE_UPDATE = 'state_update',
  FRAME_MAPPING = 'frame_mapping',
  DIALOG_ACT = 'dialog_act',
  POST_FILL_ACTION = 'post_fill_action',
  SLOT_STORAGE_ANNOTATION = 'slot_storage_annotation',
  INITIALIZATION = 'initialization',
  FILTERING = 'filtering',
  TEST_CASE = 'test_case'
}

export const ENTITY_RECOGNIZER = {
  LIST: 'list',
  DUCKLING: 'duckling'
};

export enum FillMode {
  SYNC = 'sync',
  ASYNC = 'async'
}

export enum MessagingType {
  SIMPLE = 'simple',
  RICH = 'rich'
}

export enum AskStrategy {
  ALWAYS_ASK = 'always_ask',
  CONDITIONAL = 'conditional',
  USER_MENTIONED = 'user_mentioned',  // deprecated
  NEVER_ASK = 'never_ask',
  BOOLEAN_GATE = 'boolean_gate',
  EXTERNAL_EVENT = 'external_event',
  RECOVER_ONLY = 'recover_only',
  INTERNAL_EVENT = 'internal_event'
}

export enum SourceType {
  REGULAR = 'regular',
  CODE_EXPRESSION = 'code_expression'
}

export enum ConfirmationMessageType {
  SingleValue = 'single_value',
  MultipleValue = 'multiple_value'
}

export const INTEGRATION_TYPE = {
  RESTFUL: 'restful',
  MESSENGER: 'messenger',
  // ROCKET_CHAT: 'rocket',
  TWILIO: 'twilio',
  LARK: 'lark',
  WECHAT_PUBLIC_ACCOUNT: 'wechatpa',
  RBM: 'rbm',
  TELEUNION_RCS: 'teleunion_rcs',
  WHATSAPP_BUSINESS: 'whatsapp',
  GOOGLE_BUSINESS_MESSAGE: 'gbm'
};

export enum RESPONSE_CHANNEL_TYPE {
  RESTFUL = 'restful',
  WECHAT = 'wechat',
  MESSANGER = 'messenger',
  ROCKET = 'rocket',
  TWILIO = 'twilio',
  LARK = 'lark',
  WECHAT_PUBLIC_ACCOUNT = 'wechatpa',
  RBM = 'rbm',
  TELEUNION_RCS = 'teleunion_rcs',
  WHATSAPP_BUSINESS = 'whatsapp',
  GOOGLE_BUSINESS_MESSAGE = 'gbm'
}

export const USER_CHANNEL_NAME_MAP: { [key: string]: string } = {
  restful: 'Universal',
  wechat: 'WeChat',
  messenger: 'Facebook Messenger',
  rocket: 'Rocket.Chat',
  twilio: 'Twilio',
  lark: 'Lark',
  wechatpa: 'WeChat Official Account',
  rbm: 'RCS Business Messaging',
  teleunion_rcs: 'Teleunion RCS',
  whatsapp: 'WhatsApp Business',
  gbm: 'Google Business Message'
};

export const AGENT_MODE = {
  APPLICATION: 'application',
  LIBRARY: 'library',
  KNOWLEDGE: 'knowledge'
};

export const AGENT_PRIVACY = {
  INTERNAL: 'internal',
  PUBLIC: 'public',
  PRIVATE: 'private'
};

export enum AGENT_DEPLOY_MODE {
  FRAMELY = 'framely',
  PRIVATE = 'private'
}

export enum AGENT_REGION {
  BJ = 'beijing',
  VIRGINIA = 'virginia',
  OREGON = 'aws-west-2'
}

export const DEPLOYMENT_CACHE_KEY = 'DEPLOYMENT_CACHE_KEY';

export enum AGENT_SEARCH_TYPE {
  ALL = 'all',
  COMPONENT = 'component',
  APPLICATION = 'application',
  LIBRARY = 'library',
  SERVICE = 'service',
  BACKEND = 'backend',
  KNOWLEDGE = 'knowledge'
}

export const ENTITY_NAME_KOTLIN_STRING = 'kotlin.String';

// Notifications
export const N_ORG_LIST_UPDATE = 'N_ORG_LIST_UPDATE';
export const N_AGENT_LANGUAGE_UPDATE = 'N_AGENT_LANGUAGE_UPDATE';

export const FakedProviderConnectionSlotID = '62e0d99a554be07885061e04';

// system1
export const SYSTEM1_SERVICE_NODE = {
  id: '649e37f67ba3a709d984a04d',
  name: 'io.opencui.system1.ISystem1',
  type: PAGE_TYPE.SERVICE
};

export const SYSTEM1_PROVIDER_NODE = {
  id: '649e725e7ba3a709d984be23',
  name: 'io.opencui.chatGPTSystem1',
  type: PAGE_TYPE.AGENT
};

export const KNOWLEDGE_RETRIEVER_PROVIDER_NAME = 'io.opencui.knowledgeRetriever';

export const COPILOT_ACTION_KEYS = {
  CREATE_PROJECT: 'createProject',
  CREATE_TYPE: 'createType',
  SWITCH_VIEW: 'switchView',
  ADD_SLOT: 'addSlot',
  ADD_SERVICE: 'addService',
  RESPONSE_BRANCH: 'responseBranch',
  CHANGE_SLOT_STRATEGY: 'changeSlotStrategy',
  ADD_RESPONSE_ACTION: 'addResponseAction',
  SELECT_DEPLOY_SERVICE: 'selectDeployService',
  SELECT_DEBUG_SERVICE: 'selectDebugService',
  ENABLE_STORAGE: 'EnableStorage',
  ALLOW_NULL: 'allowNull',
  INPUT_TYPE: 'inputType',
  IMPLEMENT_TYPE: 'implementType',
  SET_IMPLEMENTATION: 'setImplementation'
};

export enum FEPage {
  unknown = 'unknown',
  user = 'user',
  orgList = 'orgList',
  orgMember = 'orgMember',
  orgSetting = 'orgSetting',
  agentList = 'agentList',
  typeList = 'typeList',
  agentSetting = 'agentSetting',
  dependency = 'dependency',
  version = 'version',
  skillDetail = 'skillDetail',
  frameDetail = 'frameDetail',
  entityDetail = 'entityDetail',
  dialogActDetail = 'dialogActDetail',
  serviceSchema = 'serviceSchema',
  slotDetail = 'slotDetail',
  responseDetail = 'responseDetail',
  providerConnection = 'providerConnection',
  testCase = 'testCase'
}

export enum PlanLevel {
  Super = -1,
  Free = 0,
  FreeTrial = 1,
  Beginner = 2
}
